export default __webpack_public_path__ + "static/media/icon-chat-blue.a83f17d4.svg";